import Cookies from 'js-cookie'

export function setUserId(user_id) {
    Cookies.set('dsa_user_id', user_id)
}

export function getUserId() {
    return Cookies.get('dsa_user_id')
}

export function removeUserId() {
    Cookies.remove('dsa_user_id')
}

export function setUserName(user_name) {
    Cookies.set('dsa_user_name', user_name)
}

export function getUserName() {
    return Cookies.get('dsa_user_name')
}

export function removeUserName() {
    Cookies.remove('dsa_user_name')
}

export function setStudentEmail(email) {
    Cookies.set('dsa_student_email', email)
}

export function getStudentEmail() {
    return Cookies.get('dsa_student_email')
}

export function removeStudentEmail() {
    Cookies.remove('dsa_student_email')
}

/** Test checkout amount (USD 0.50, Stripe floor) for designated QA accounts. */
export function isTestPayUser() {
    const email = (getStudentEmail() || '').toLowerCase()
    return email === '1050622448@qq.com'
}

export function getTestPayAmountUsd() {
    return 0.50
}

export function setUserType(user_type) {
    Cookies.set('dsa_user_type', user_type)
}

export function removeUserType() {
    Cookies.remove('dsa_user_type')
}

export function getProjectCode() {
    return Cookies.get('dsa_project_code') || 'DSA'
}

export function setAccountName(account_name) {
    Cookies.set('dsa_account_name', account_name)
}

export function getAccountName() {
    return Cookies.get('dsa_account_name')
}

export function removeAccountName() {
    Cookies.remove('dsa_account_name')
}

export function setInstitutionAccountId(account_id) {
    Cookies.set('dsa_account_id', account_id)
}

export function getInstitutionAccountId() {
    return Cookies.get('dsa_account_id')
}

export function removeInstitutionAccountId() {
    Cookies.remove('dsa_account_id')
}

/** Advisor / contact id for institution registration attribution. */
export function setInstitutionAdvisorId(advisor_id) {
    if (advisor_id) Cookies.set('dsa_advisor_id', advisor_id)
    else Cookies.remove('dsa_advisor_id')
}

export function getInstitutionAdvisorId() {
    return Cookies.get('dsa_advisor_id') || ''
}

export function removeInstitutionAdvisorId() {
    Cookies.remove('dsa_advisor_id')
}

export function logoutInstitution() {
    removeInstitutionAccountId()
    removeInstitutionAdvisorId()
    removeUserType()
    removeUserName()
    removeAccountName()
}

export function getAppId() {
    return Cookies.get('app_id')
}

export function logout() {
    Cookies.remove('dsa_project_code')
    removeUserId()
    removeUserType()
    removeUserName()
    removeInstitutionAccountId()
    removeInstitutionAdvisorId()
    removeStudentEmail()
    removeAccountName()
    Cookies.remove('app_id')
    Cookies.remove('avatar_url')
    Cookies.remove('test_event')
    Cookies.remove('project_name')
}

export function getUserIP(onNewIP) {
    let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
    if (!MyPeerConnection) {
        onNewIP && onNewIP('')
        return
    }
    let pc = new MyPeerConnection({ iceServers: [] })
    let noop = () => {}
    let localIPs = {}
    let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
    let iterateIP = (ip) => {
        if (!localIPs[ip]) onNewIP(ip)
        localIPs[ip] = true
    }
    pc.createDataChannel('')
    pc.createOffer().then((sdp) => {
        sdp.sdp.split('\n').forEach(function(line) {
            if (line.indexOf('candidate') < 0) return
            const m = line.match(ipRegex)
            if (m) m.forEach(iterateIP)
        })
        pc.setLocalDescription(sdp, noop, noop)
    }).catch(() => {})
    pc.onicecandidate = (ice) => {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
    }
}
